module.exports = __webpack_public_path__ + "static/media/downArrow.b0460461.svg";